import dayjs from "@/utiles/dayjs";
const canceledOrderCard = () =>
  import("@/components/OrderProcessPage/Withdrawal/CanceledOrderCard/index");
const OtpOrder = () => import("@/components/Shared/OtpOrder/index");
import { TransferService, OperationService } from "@/services";
import * as types from "@/store/types";
import { mapActions, mapGetters } from "vuex";
import $thousandMask from "@/mixins/thousandMask";
import initService from "@/services/modules/initService";
const Captcha = () =>
  import(/* webpackChunkName: "Captcha" */ "@/components/Captcha/index");

export default {
  name: "transfer",
  components: { canceledOrderCard, Captcha, OtpOrder },
  props: [],
  mixins: [$thousandMask],
  filters: {
    dateTimeFilter(date) {
      return (
        dayjs(date).format("HH:mm") + " - " + dayjs(date).format("YYYY/MM/DD")
      );
    }
  },
  data() {
    return {
      dialog: false,
      orderAmount: "",
      orderCurrencyId: "",
      orderIso: "",
      processStep: {},
      defaultProcessStep: {
        id: "",
        status: "",
        step: ""
      },
      phoneNumber: "",
      otpCode: "",
      orderData: {},
      toggleMethod: false,
      value: 100,
      confirmLoading: false,
      expiredOtpTimestamp: 0,
      isCounterExpired: false,
      countdownTimer: "",
      clockInterval: "",
      counterTime: 0,
      copyFlag: true,
      captcha_token: null,
      captcha_value: null,
      captcha_hash: null,
      reloadCaptcha: false,
      marketUrl: process.env.VUE_APP_MARKET_BASE_URL,
      waitRequest: false,
      captchaStatus: false
    };
  },
  computed: {
    ...mapGetters({
      getTransferData: types.transfer.getters.GET_TRANSFER_TO_MARKET,
      getProcessingOrder: types.operations.getters.GET_PROCESSING_ORDER,
      getOrderStep: types.operations.getters.GET_ORDER_STEP,
      getUserInfo: types.userInfo.getters.GET_USER_INFO,
      getCancelOrderStep: types.operations.getters.GET_CANCEL_ORDER_STEP
    }),
    getCancelOrderStepData() {
      if (this.getCancelOrderStep) {
        return this.getCancelOrderStep;
      }
    },
    showTransferData() {
      let data = {
        logo: "",
        iso: "",
        transferAmount: "",
        id: ""
      };
      if (Object.entries(this.getTransferData).length > 0) {
        data = this.getTransferData;
      }
      return data;
    },
    processingOrderData() {
      if (this.getProcessingOrder) {
        return this.getProcessingOrder;
      }
    },
    transferOrderStep() {
      if (Object.entries(this.getOrderStep).length !== 0) {
        return this.getOrderStep.transferToMarket;
      }
    },
    userInfo() {
      if (Object.entries(this.getUserInfo).length > 0) {
        return this.getUserInfo;
      }
    },
    orderTransactionId() {
      return this.$route.params.id || this.$route.params.coin;
    }
  },
  watch: {
    showTransferData: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          if (newValue.iso === "") {
            OperationService.showOrder(this.orderTransactionId).catch(error => {
              if (error.status === 404) {
                this.$router.push({
                  path: `/operations/transfer`
                });
              }
            });
          }
          this.orderAmount = newValue.transferAmount;
          this.orderCurrencyId = newValue.id;
          this.orderIso = newValue.iso;
        }
      }
    },
    orderTransactionId: {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal === this.orderIso) {
          this.processStep = {
            id: 1,
            status: "CREATED",
            step: "confirm"
          };
          this.cancelOrderStep(this.processStep.id);
        } else if (newVal !== oldVal) {
          this.getOrderData();
        }
      }
    }
  },
  beforeDestroy() {
    clearInterval(this.clockInterval);
    Object.assign(this.processStep, this.defaultProcessStep);
  },
  mounted() {
    // this.getOrderData();
    this.getCaptchaStatus();
  },
  methods: {
    ...mapActions({
      setProcessingOrder: types.operations.actions.ACTION_PROCESSING_ORDER,
      cancelOrderStep: types.operations.actions.ACTION_CANCEL_ORDER_STEP
    }),
    getCaptchaStatus() {
      initService.initSecurity().then(res => {
        this.captchaStatus = res.data.data.captcha.orders_market_transfer;
      });
    },
    cancelOrder() {
      this.dialog = true;
    },
    onCancelOrder(event) {
      let data = {
        ref_no: this.orderTransactionId
      };
      OperationService.cancelOrder(data).then(() => {
        if (event !== undefined) {
          this.dialog = false;
          this.$router.push(`/operations/transfer`);
        }
      });
    },
    confirmOrder() {
      this.waitRequest = true;
      let data = {
        amount: this.orderAmount,
        currency_id: this.$route.query.currency_id,
        captcha_token: this.captcha_token,
        captcha_value: this.captcha_value
      };
      TransferService.transferToMarket(data)
        .then(response => {
          if (
            response.data.data["needs_otp_verification"] &&
            this.transferOrderStep.length === 3
          ) {
            window.location = `${process.env.VUE_APP_BASE_URL}/submit-order/${response.data.data.ref_no}/transfer`;
          }
          this.$router.push({
            name: "transfer-process-id",
            params: {
              id: response.data.data.ref_no
            }
          });
        })
        .catch(error => {
          this.getOrderData();
          this.captcha_token = null;
          this.captcha_value = null;
          this.captcha_hash = error.data.captcha_hash;
        })
        .finally(() => {
          this.waitRequest = false;
          this.reloadCaptcha = !this.reloadCaptcha;
        });
    },
    captchaChanged(captchaData) {
      this.captcha_token = captchaData.token;
      this.captcha_value = captchaData.value;
    },
    verifyOtp() {
      let data = {
        ref_no: this.orderTransactionId,
        verification_code: this.otpCode
      };
      OperationService.verifyOrderOtp(data).then(() => {
        this.getOrderData();
      });
    },
    createOrderTransactionId() {
      if (this.copyFlag) {
        this.copyFlag = false;
        this.$toast.success(this.$t("orderProcessPage.txNumberCopied"));
      } else {
        setTimeout(() => {
          this.copyFlag = true;
        }, 3000);
      }
    },
    getOrderData() {
      this.confirmLoading = true;
      OperationService.showOrder(this.orderTransactionId)
        .then(response => {
          this.expiredOtpTimestamp = response.data.data.sms_expires_in;
          this.isCounterExpired = false;
          this.countdown(this.expiredOtpTimestamp);
          this.setProcessingOrder(response.data.data);
          let activeStep = {
            step: response.data.data.step,
            status: response.data.data.status
          };
          if (
            response.data.data.status === "EXPIRED" ||
            response.data.data.status === "CANCELED"
          ) {
            this.$router.push({
              path: "/operations/transfer",
              query: { from: "" }
            });
          }
          if (this.transferOrderStep) {
            this.transferOrderStep.forEach(elem => {
              if (elem.step === activeStep.step) {
                this.processStep = {
                  id: elem.id,
                  status: activeStep.status,
                  step: elem.step
                };
                this.cancelOrderStep(this.processStep.id);
              }
            });
          }
        })
        .finally(() => {
          this.confirmLoading = false;
        });
    },
    resendSms() {
      let data = {
        ref_no: this.orderTransactionId
      };
      OperationService.resendOrderVerification(data)
        .then(() => {
          this.getOrderData();
        })
        .catch(() => {
          this.getOrderData();
        });
    },
    countdown(distance) {
      distance = distance / 1000;
      this.clockInterval = setInterval(() => {
        distance--;
        let minutes = Math.floor(distance / 60);
        let seconds = Math.floor(distance % 60);
        if (minutes < 10) {
          minutes = "0" + minutes;
        }
        if (seconds < 10) {
          seconds = "0" + seconds;
        }
        let x = minutes + ":" + seconds;
        if (distance < 0) {
          this.countdownTimer = "00:00";
          this.isCounterExpired = true;
          clearInterval(this.clockInterval);
        } else {
          this.countdownTimer = x;
        }
      }, 1000);
    },
    changeUrl() {
      window.location.replace(this.marketUrl);
    }
  }
};
